export default __webpack_public_path__ + "img/sagoo/sagoo1_700.jpg";